import React, { useEffect, useState } from "react";

export default function (props) {
  const { filters, setFilters } = props;
  const updateFilters = (btnNumber) => {
    let newTravauxValue;

    // Determine the new value based on btnNumber and current filters.travaux value
    if (filters.travaux === 3) {
      newTravauxValue = btnNumber === 1 ? 2 : 1;
    } else if (filters.travaux === 2) {
      newTravauxValue = btnNumber === 1 ? 3 : 1;
    } else if (filters.travaux === 1) {
      newTravauxValue = btnNumber === 1 ? 2 : 3;
    } else {
      newTravauxValue = btnNumber === 1 ? 1 : 2;
    }

    // Update filters state
    setFilters({
      ...filters,
      travaux: newTravauxValue,
    });
  };

  return (
    <>
      <div>
        <h4>Travaux</h4>
        <div className="mt-2">
          <button
            onClick={() => {
              updateFilters(1);
            }}
            className={
              [0, 2].includes(filters.travaux)
                ? "btn-outline-orangered me-2 px-3 py-2 fs-6 rounded"
                : "btn-orangered me-2 px-3 py-2 fs-6 rounded"
            }
          >
            Entrants ( {filters.entredWorks} ){" "}
          </button>
          <button
            onClick={() => updateFilters(2)}
            className={
              [0, 1].includes(filters.travaux)
                ? "btn-outline-main me-2 px-3 py-2 fs-6 rounded"
                : "btn-main me-2 px-3 py-2 fs-6 rounded"
            }
          >
            Sortants ( {filters.sortedWorks} ){" "}
          </button>
        </div>
      </div>
    </>
  );
}
